// Builds the CSV row set for the Director Strategy Dashboard export, scoped to the ACTIVE tab so the
// download reflects what the user is looking at (previously it always dumped one generic bizData row).
// Pure + tested: see strategyExport.test.js. Missing values are emitted as '' (honest blank), never a
// fabricated 0.
const n = (v) => (v == null ? '' : v);

export function strategyExportRows(tab, { bizData, chatData, voiceData, execData } = {}) {
  switch (tab) {
    case 'resolution_trend': {
      const daily = (bizData && bizData.daily_metrics) || [];
      const rows = daily.map((d) => ({
        date: n(d.date), tickets: n(d.tickets), resolved: n(d.resolved), escalated: n(d.escalated),
      }));
      // Trailing summary row uses authoritative totals (blank when absent).
      rows.push({
        date: 'TOTAL',
        tickets: n(bizData && bizData.total_tickets),
        resolved: n(bizData && bizData.resolved_tickets),
        escalated: '',
      });
      return rows;
    }
    case 'intent_analysis': {
      const dist = (chatData && chatData.intent_distribution) || {};
      return Object.entries(dist).map(([intent, count]) => ({ intent, count }));
    }
    case 'voice_channel': {
      if (!voiceData) return [];
      return [{
        total_calls: n(voiceData.total_calls),
        ai_handled: n(voiceData.ai_handled),
        ai_resolved: n(voiceData.ai_resolved),
        human_escalated: n(voiceData.human_escalated),
        escalation_rate: n(voiceData.escalation_rate),
        avg_call_duration: n(voiceData.avg_call_duration),
        pending_callbacks: n(voiceData.pending_callbacks),
        overdue_callbacks: n(voiceData.overdue_callbacks),
      }];
    }
    case 'operational': {
      if (!bizData) return [];
      return [{
        callback_rate: n(bizData.callback_rate),
        openai_usage_rate: n(bizData.openai_usage_rate),
        active_tickets: n(execData && execData.active_tickets),
        voice_total_calls: n(voiceData && voiceData.total_calls),
        voice_ai_resolved: n(voiceData && voiceData.ai_resolved),
        reopened_conversations: n(bizData.reopened_conversations),
      }];
    }
    default:
      return bizData ? [bizData] : [];
  }
}

export default strategyExportRows;
